import { useEffect, useState } from "react";
import { socket } from "./socket";
import { API_URL } from "./config";
import { data } from "autoprefixer";
const room_done = require('./images/room_green.png')
const room_pending = require('./images/room_yellow.png')
const calendarImg = require('./images/calendar.png')
const groupHK = 'C65309ec1b6d4eccc2cfb21a7507e3857'
const groupENG = 'Ce4184f94add3a6a4fa900a812ff251c6'


function App() {
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetch(`${API_URL}/api/orders`)
      .then(res => res.json())
      .then(data => setOrders(data));
      console.log('data', data)

    socket.on("order:new", (order) => {
      setOrders(prev => [order, ...prev]);
    });

    socket.on("order:update", (updated) => {
      setOrders(prev =>
        prev.map(o =>
          o.id === updated.id ? { ...o, status: updated.status } : o
        )
      );
    });

    return () => {
      socket.off("order:new");
      socket.off("order:update");
    };
  }, []);

const sendReply = async (orderId) => {
  await fetch(`${API_URL}/api/reply`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      orderId,
      text: '🔔 Please follow up on this request.'
    })
  });
};

return (
  // main block
<div className="m-10 p-5 h-full shadow-lg rounded-lg bg-gray-100"> 
    {/* inner block */}
    <div className="flex flex-col gap-5">
      {/* in progress */}
      <div className="w-full p-2 grid grid-cols-3 gap-3">
        {orders.filter(o => o.status === 'pending').map(o => {
            const formattedDate = new Date(o.createdAt).toLocaleString('en-GB', {
              day: 'numeric',
              month: 'short',
              hour: '2-digit',
              minute: '2-digit',
            });
            const room = o.text.match(/[A-Z]\d{3}/)?.[0];

            return(
            <div className="border-l-4 border-yellow-500 p-4 bg-white rounded-lg w-full flex flex-col gap-5">
              <div className="flex justify-between items-center">
                <div className="flex gap-2 items-center">
                  <div className="p-1 bg-orange-100 rounded-lg">
                    <img src={room_pending} className="w-8 h-8"></img>
                  </div>
                  <p className="text-lg font-bold uppercase">{room ? room : '---'}</p>
                </div>
                <p className="bg-orange-100 pl-3 pr-3 uppercase rounded-lg font-bold text-yellow-500">{o.status}</p>
              </div>

              <div>
                <p>{o.text}</p> 
              </div>

              <div className="border-t border-gray-200 pt-2 flex items-center gap-3 pl-1">
                <img src={calendarImg} className="w-4 h-4 opacity-60"></img>
                <p className="text-gray-500 text-sm">{formattedDate}</p>
              </div>

              <button className="w-fit bg-gray-100 rounded-lg text-sm pl-2 pr-2 hover:bg-blue-200 hover:transition" onClick={() => sendReply(o.id)}>
                Summon
              </button>
              {/* <p>{o.group === groupENG ? 'ENG' : 'HK'}</p> */}
          </div>
            )
        })}
      </div>
      {/* completed */}
      <div className="flex items-center gap-3">
        <div className="flex-1 border-t-2 border-green-500"></div>
        <p className="font-bold text-green-500">COMPLETED</p>
        <div className="flex-1 border-t-2 border-green-500"></div>
      </div>
      <div className="w-full p-2 grid grid-cols-3 gap-3">
        {orders.filter(o => o.status === 'done').map(o => {
            const formattedDate = new Date(o.createdAt).toLocaleString('en-GB', {
              day: 'numeric',
              month: 'short',
              hour: '2-digit',
              minute: '2-digit',
            });
            const room = o.text.match(/[A-Z]\d{3}/)?.[0];

            return(
            <div className="h-fit border-l-4 border-green-500 p-4 bg-white rounded-lg w-full flex flex-col gap-5">
              <div className="flex justify-between items-center">
                <div className="flex gap-2 items-center">
                  <div className="p-1 bg-green-100 rounded-lg">
                    <img src={room_done} className="w-8 h-8"></img>
                  </div>
                  <p className="text-lg font-bold uppercase">{room ? room : '---'}</p>
                </div>
                <p className="bg-green-100 pl-3 pr-3 uppercase rounded-lg font-bold text-green-500">{o.status}</p>
              </div>

              <div>
                <p className="text-sm">{o.text}</p> 
              </div>

              <div className="border-t border-gray-200 pt-2 flex items-center gap-3 pl-1">
                <img src={calendarImg} className="w-4 h-4 opacity-60"></img>
                <p className="text-gray-500 text-sm">{formattedDate}</p>
              </div>

              {/* <p>{o.group === groupENG ? 'ENG' : 'HK'}</p> */}
          </div>
            )
        })}
      </div>

    </div>
</div>
);
}

export default App;

